import {Box, Heading, Icon, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

export function FinancingEndingEmailIntro() {
  return (
    <Box paddingHorizontal={[4, 4, 10]}>
      <VStack spacing={4} align="center" justify="center">
        <Icon value="action/mail_upload" color="palettes.blue.30.100" isNotFilled size={20} />
        <Heading size={3}>
          {i18n.t('entity.businessCase.financingEnding.dialog.introTitle')}
        </Heading>
        <Text color="secondary" align="center">
          {i18n.t('entity.businessCase.financingEnding.dialog.introDescription')}
        </Text>
      </VStack>
    </Box>
  );
}
